import type { HereAndNowTab } from "@lib/logic";

import { FacilityDetails } from "./details/facility/FacilityDetails";
import { PersonDetails } from "./details/person/PersonDetails";
import { RoomDetails } from "./details/room/RoomDetails";
import { WorkspaceDetails } from "./details/workspace/WorkspaceDetails";
import { Facilities } from "./facilities/Facilities";
import { People } from "./people/People";
import { Rooms } from "./rooms/Rooms";
import { HaN } from "./shell/HaN";
import { Workspaces } from "./workspaces/Workspaces";

export const HereAndNowRevamp = ({ tab }: { tab: HereAndNowTab }) => {
  return (
    <HaN.Page tab={tab}>
      <HaN.Header />
      <HaN.CalendarSyncTile />

      <HaN.TabsBar>
        <HaN.Search />
        <HaN.Tabs />
      </HaN.TabsBar>

      <HaN.FilterBar>
        <Rooms.Filters />
        <Workspaces.Filters />
      </HaN.FilterBar>

      <HaN.List>
        <Rooms.List />
        <Workspaces.List />
        <People.List />
        <Facilities.List />
      </HaN.List>

      <HaN.MapStage>
        <Rooms.Map />
        <Workspaces.Map />
        <People.Map />
        <Facilities.Map />
      </HaN.MapStage>

      <HaN.Carousel>
        <Rooms.Carousel />
        <Workspaces.Carousel />
        <People.Carousel />
        <Facilities.Carousel />
      </HaN.Carousel>

      <HaN.FloorSelector />

      <HaN.Details>
        <RoomDetails />
        <WorkspaceDetails />
        <PersonDetails />
        <FacilityDetails />
      </HaN.Details>
    </HaN.Page>
  );
};
